export class AerovaleDetalleCombustible {
    aforadorInicio: number;
    aforadorFinal: number;
    temperatura: number;
    densidad: number;
    volumen15grados: number;     
    codigoTanque: string;
    picoId: string; 
}